import groq from 'groq';

import {
  BANNER_BLOCK,
  BEFORE_AFTER_BLOCK,
  BENEFIT_CARDS_BLOCK,
  BENEFITS_V2_BLOCK,
  BLOG_CAROUSEL_BLOCK,
  CATEGORIES_INTRO_BLOCK,
  CHART_BLOCK,
  COMPARISON_TABLE_BLOCK,
  FACTS_BLOCK,
  FAQ_BLOCK,
  FEATURE_LIST_BLOCK,
  HALO_SHOWCASE_BLOCK,
  ICONS_LIST_BLOCK,
  IMAGE_WITH_CALLOUTS_BLOCK,
  KEY_INGREDIENTS_BLOCK,
  LISTICLE_ITEM_BLOCK,
  MEDIA_BLOCK,
  MITOCHONDRIAL_DECLINE_BLOCK,
  MITOPURE_TRANSFORMATION_BLOCK,
  ONWARDS_5050_BLOCK,
  PODCAST_BANNER_BLOCK,
  PRESS_QUOTES_BLOCK,
  PRODUCT_BLOCK,
  PRODUCT_BUNDLE_BLOCK,
  PRODUCT_CAROUSEL_BLOCK,
  PRODUCT_COMPARISON_BLOCK,
  QUOTE_CAROUSEL_BLOCK,
  REVIEWS_CAROUSEL_BLOCK,
  SIGNUP_BANNER_BLOCK,
  SKINCARE_FORMAT_PICKER_BLOCK,
  SOCIAL_MEDIA_CAROUSEL_BLOCK,
  SUPPLEMENT_PICKER_BLOCK,
  TESTIMONIAL_GROUP_BLOCK,
  TEXT_BLOCK,
  TEXT_MEDIA_SPLIT_BLOCK,
  VIBE_GALLERY_BLOCK,
  WALL_OF_LOVE_BLOCK,
} from '../blocks';

export const CAMPAIGN_BLOCKS = groq`
  _key,
  _ref,
  _type,
  ${FACTS_BLOCK},
  ${QUOTE_CAROUSEL_BLOCK},
  ${PRODUCT_BLOCK},
  ${BANNER_BLOCK},
  ${SIGNUP_BANNER_BLOCK},
  ${BENEFIT_CARDS_BLOCK},
  ${BENEFITS_V2_BLOCK},
  ${TEXT_MEDIA_SPLIT_BLOCK},
  ${PRODUCT_CAROUSEL_BLOCK},
  ${TESTIMONIAL_GROUP_BLOCK},
  ${FAQ_BLOCK},
  ${PODCAST_BANNER_BLOCK},
  ${PRESS_QUOTES_BLOCK},
  ${MITOPURE_TRANSFORMATION_BLOCK},
  ${COMPARISON_TABLE_BLOCK},
  ${LISTICLE_ITEM_BLOCK},
  ${ICONS_LIST_BLOCK},
  ${PRODUCT_BUNDLE_BLOCK},
  ${REVIEWS_CAROUSEL_BLOCK},
  ${WALL_OF_LOVE_BLOCK},
  ${BLOG_CAROUSEL_BLOCK},
  ${ONWARDS_5050_BLOCK},
  ${SOCIAL_MEDIA_CAROUSEL_BLOCK},
  ${FEATURE_LIST_BLOCK},
  ${PRODUCT_COMPARISON_BLOCK},
  ${KEY_INGREDIENTS_BLOCK},
  ${MEDIA_BLOCK},
  ${TEXT_BLOCK},
  ${VIBE_GALLERY_BLOCK},
  ${SUPPLEMENT_PICKER_BLOCK},
  ${SKINCARE_FORMAT_PICKER_BLOCK},
  ${BEFORE_AFTER_BLOCK},
  ${IMAGE_WITH_CALLOUTS_BLOCK},
  ${CATEGORIES_INTRO_BLOCK},
  ${CHART_BLOCK},
  ${MITOCHONDRIAL_DECLINE_BLOCK},
  ${HALO_SHOWCASE_BLOCK}
`;
